exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Divider{background:var(--gray-5)}.Divider.row{width:1px;height:auto;margin:4px 0}.Divider.column{width:auto;height:1px;margin:0 4px}", ""]);

// exports
